import { Component, computed, inject, input, output } from '@angular/core';
import {
  ColumnDef,
  RowSelectionState,
  SortingState,
  TableComponent as SdcTableComponent,
} from '@3ddv/software-division-components/backoffice/table';
import { PageNavigationService } from '../../../core/services/page-navigation.service';
import { GsLoaderComponent } from '../loader/gs-loader.component';

@Component({
  selector: 'gs-table',
  templateUrl: './gs-table.component.html',
  styleUrls: ['./gs-table.component.css'],
  imports: [SdcTableComponent, GsLoaderComponent],
})
export class GsTableComponent {
  readonly data = input<Record<string, any>[]>([]);
  readonly columns = input<ColumnDef<any>[]>([]);

  readonly selectable = input(false);

  readonly sortable = input<boolean | string[]>(false);

  readonly className = input('');

  readonly pinningHeaders = input(false);

  readonly loading = input(false);

  private readonly pageNavigation = inject(PageNavigationService);

  protected readonly showLoader = computed(
    () => this.loading() || this.pageNavigation.changing()
  );

  readonly selectionChange = output<RowSelectionState>();
  readonly sortingChange = output<SortingState>();
}
